var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-skeleton',_vm._b({style:(_vm.inline ? 'display: inline-block;' : null),attrs:{"width":_vm.width ? _vm.width : `${Math.floor(Math.random() * _vm.maxRandomWidth) + _vm.minRandomWidth}${_vm.randomWidthUnit}`,"height":_vm.height ? _vm.height : null,"square":_vm.square,"animation":_vm.animation}},'q-skeleton',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }